/**
 * Converts the proprietary ===MARKER=== article format to HTML for TipTap.
 *
 * Marker types:
 *   ===HEADER_N===   — next non-blank line becomes <h2>
 *   ===BLOCK_N===    — structural only; stripped (following text becomes <p> blocks)
 *   ===INTRO_BLOCK=== — structural only; stripped
 *   ===PROMO===  / ===PROMO_N===  — following text becomes <blockquote class="promo-block">
 *
 * Blank lines separate paragraphs within a block.
 */
export function parseArticleContentToHtml(rawContent) {
  if (!rawContent) return '<p></p>';

  const lines = rawContent.split('\n');
  const htmlParts = [];
  let mode = 'paragraph'; // 'paragraph' | 'heading' | 'promo'

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i];
    const trimmed = line.trim();

    if (/^===HEADER_\d+===$/.test(trimmed)) {
      mode = 'heading';
      continue;
    }

    if (/^===BLOCK_\d+===$/.test(trimmed) || trimmed === '===INTRO_BLOCK===') {
      mode = 'paragraph';
      continue;
    }

    if (/^===PROMO(_\d+)?===$/.test(trimmed)) {
      mode = 'promo';
      continue;
    }

    // Skip other unknown markers
    if (/^===.+===$/.test(trimmed)) {
      mode = 'paragraph';
      continue;
    }

    if (trimmed === '') {
      // blank line — paragraph boundary; reset heading mode
      if (mode === 'heading') mode = 'paragraph';
      continue;
    }

    if (mode === 'heading') {
      htmlParts.push(`<h2>${escapeHtml(trimmed)}</h2>`);
      mode = 'paragraph';
    } else if (mode === 'promo') {
      htmlParts.push(`<blockquote class="promo-block"><p>${escapeHtml(trimmed)}</p></blockquote>`);
    } else {
      htmlParts.push(`<p>${escapeHtml(trimmed)}</p>`);
    }
  }

  return htmlParts.length > 0 ? htmlParts.join('\n') : '<p></p>';
}

function escapeHtml(str) {
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
